var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.826725 0.163933C1.02152 -0.0347736 1.32635 -0.0528378 1.54116 0.10974L1.6027 0.163933L5.99935 4.64894L10.396 0.163933C10.5908 -0.0347736 10.8956 -0.0528378 11.1104 0.10974L11.172 0.163933C11.3668 0.362639 11.3845 0.673582 11.2251 0.892695L11.172 0.95547L6.38734 5.83607C6.19254 6.03477 5.88771 6.05284 5.6729 5.89026L5.61136 5.83607L0.826725 0.95547C0.612446 0.736893 0.612446 0.38251 0.826725 0.163933Z",
    fill: "#200E32"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-arrow-down.deca7353.svg";
export { ForwardRef as ReactComponent };